export const initialResponse = {
  status: 0,
  message: '',
};
